import React from 'react';
import { Container } from 'react-bootstrap';
import ReactMapGL, {
  Marker, 
  FullscreenControl, 
  GeolocateControl, 
  NavigationControl
} from 'react-map-gl';
import pin from '../assets/pin.webp'


const Map = () => {
  return (
    <Container className='my-5 pb-5' fluid>
      <ReactMapGL
        initialViewState={{ latitude: 48.87, longitude: 2.3, zoom: 5.5 }}
        mapStyle="mapbox://styles/mapbox/streets-v9"
        style={{ height:"500px", width: "100%"}}
        attributionControl={false}
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
      > 
        <GeolocateControl
          positionOptions={{enableHighAccuracy: true}}
          trackUserLocation={false}
        />
        <FullscreenControl />
        <Marker longitude={2.3} latitude={48.87} anchor="bottom" >
          <img style={{width:"21px", height:"14px",top:"-11px", bottom: "-7px"}} src={pin} alt="pin" />
        </Marker>
        <NavigationControl visualizePitch={true}/>
      </ReactMapGL>
    </Container>
  );
};

export default Map
